import { memo } from 'react'

/**
 * Dashed outline drawn around the AI-generated draft content
 * (stroke #3389E0, fill #E6F0FB, 4px dashes, radius 4).
 * Non-interactive; sits behind the swimlanes.
 */
function AiPreviewOutlineNode() {
  return (
    <div
      data-testid="bpmn-ai-preview-outline"
      style={{
        width: '100%',
        height: '100%',
        border: '4px dashed #3389E0',
        background: '#E6F0FB',
        borderRadius: 4,
        pointerEvents: 'none',
      }}
    />
  )
}

export default memo(AiPreviewOutlineNode)
